import React, { lazy, memo } from 'react';
import { ArrowRightIcon, ClockIcon, ShieldCheckIcon, TruckIcon, AlertTriangleIcon, TimerIcon, CreditCardIcon, ShieldIcon, CheckCircleIcon, DollarSignIcon } from 'lucide-react';
import { trackPurchaseClick, trackAddToCart } from './MetaPixel';
const CTASection = () => {
  const handleMainCTAClick = () => {
    // Registrar evento de compra con el pixel
    trackPurchaseClick('main_cta_section', 25);
    trackAddToCart(25);
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  return <section className="py-16 md:py-24 bg-gradient-to-b from-white to-[#eef2ff]" data-id="element-53">
      <div className="container mx-auto px-4 md:px-6" data-id="element-54">
        <div className="max-w-4xl mx-auto" data-id="element-55">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-56">
            <div className="p-8 md:p-12" data-id="element-57">
              <div className="text-center mb-8" data-id="element-58">
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#1e293b]" data-id="element-59">
                  Cada día que lo postergas es un día que{' '}
                  <span className="relative inline-block" data-id="element-60">
                    pierdes
                    <span className="absolute -bottom-1 left-0 w-full h-1 bg-[#e53e3e] rounded-full" data-id="element-61"></span>
                  </span>
                </h2>
                <div className="bg-gradient-to-r from-[#fff5f5] to-[#ffe5e5] border-l-4 border-[#e53e3e] p-4 my-6 rounded-r-lg relative overflow-hidden animate-pulse" data-id="element-62">
                  <div className="absolute top-0 right-0 w-24 h-24 -mr-8 -mt-8 bg-[#fed7d7] rounded-full opacity-20 animate-ping" data-id="element-63"></div>
                  <div className="flex items-start" data-id="element-64">
                    <AlertTriangleIcon size={24} className="text-[#e53e3e] mr-3 shrink-0 mt-1 animate-bounce" data-id="element-65" />
                    <div data-id="element-66">
                      <p className="text-xl text-[#4a5568] font-medium" data-id="element-67">
                        <span className="text-[#e53e3e] font-bold tracking-wider scale-y-110 inline-block transform" data-id="element-68">
                          ¡ALERTA DE URGENCIA!
                        </span>{' '}
                        No solo por el dolor. Sino por lo que podrías haber{' '}
                        <span className="font-bold underline decoration-[#e53e3e] decoration-2 underline-offset-2 hover:bg-[#fff0f0] transition-colors" data-id="element-69">
                          logrado sin él
                        </span>
                        .
                      </p>
                      <div className="flex items-center mt-2" data-id="element-70">
                        <TimerIcon size={18} className="text-[#e53e3e] mr-2 animate-pulse" data-id="element-71" />
                        <p className="text-lg text-[#4a5568] group" data-id="element-72">
                          🔥 Promoción activa por{' '}
                          <span className="font-bold relative inline-block group-hover:animate-pulse" data-id="element-73">
                            tiempo limitado
                            <span className="absolute -bottom-1 left-0 w-0 group-hover:w-full h-0.5 bg-[#e53e3e] transition-all duration-300" data-id="element-74"></span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-xl text-[#4a5568] font-medium mt-4" data-id="element-75">
                  El momento es{' '}
                  <span className="text-[#8b5cf6] font-bold relative inline-block" data-id="element-76">
                    ahora
                    <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#8b5cf6]" data-id="element-77"></span>
                  </span>
                  .
                </p>
              </div>
              <div className="bg-[#f8f9ff] p-6 rounded-xl mb-8 transform transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-78">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-79">
                  <div className="md:w-1/2" data-id="element-80">
                    <div className="mb-6" data-id="element-81">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aWDiXTg43FXokDxPdSNdzN/freepik__reemplaza-los-ojos-de-la-mujer-con-un-antifaz-negr__84284.png" alt="Corona de Alivio 360 - Gorro rosa con tecnología de alivio" className="w-full h-auto rounded-lg shadow-md" width="500" height="400" loading="lazy" data-id="element-82" />
                    </div>
                    <h3 className="text-2xl font-semibold mb-4 text-[#1e293b]" data-id="element-83">
                      Rutina de Alivio Completa
                    </h3>
                    <ul className="space-y-3" data-id="element-84">
                      <li className="flex items-start group transition-transform duration-200 hover:translate-x-1" data-id="element-85">
                        <ShieldCheckIcon size={20} className="text-[#4ade80] mt-1 mr-3 shrink-0 group-hover:scale-110 transition-transform" data-id="element-86" />
                        <span className="text-[#4a5568]" data-id="element-87">
                          Dispositivo terapéutico 360°
                        </span>
                      </li>
                      <li className="flex items-start group transition-transform duration-200 hover:translate-x-1" data-id="element-88">
                        <ShieldCheckIcon size={20} className="text-[#4ade80] mt-1 mr-3 shrink-0 group-hover:scale-110 transition-transform" data-id="element-89" />
                        <span className="text-[#4a5568]" data-id="element-90">
                          Tecnología frío/calor ajustable
                        </span>
                      </li>
                      <li className="flex items-start group transition-transform duration-200 hover:translate-x-1" data-id="element-91">
                        <ShieldCheckIcon size={20} className="text-[#4ade80] mt-1 mr-3 shrink-0 group-hover:scale-110 transition-transform" data-id="element-92" />
                        <span className="text-[#4a5568]" data-id="element-93">
                          Recupera hasta 40 horas mensuales
                        </span>
                      </li>
                      <li className="flex items-start group transition-transform duration-200 hover:translate-x-1" data-id="element-94">
                        <ShieldCheckIcon size={20} className="text-[#4ade80] mt-1 mr-3 shrink-0 group-hover:scale-110 transition-transform" data-id="element-95" />
                        <span className="text-[#4a5568]" data-id="element-96">
                          Garantía de satisfacción 30 días
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="md:w-1/2 text-center md:text-right" data-id="element-97">
                    <div className="mb-4" data-id="element-98">
                      <span className="text-[#a0aec0] line-through text-xl" data-id="element-99">
                        $50
                      </span>
                      <span className="text-3xl font-bold text-[#1e293b] ml-2 relative inline-block animate-pulse" data-id="element-100">
                        $25
                        <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-[#8b5cf6]" data-id="element-101"></span>
                      </span>
                    </div>
                    <div className="flex items-center justify-center md:justify-end text-[#4a5568] mb-6" data-id="element-102">
                      <TruckIcon size={18} className="mr-2 text-[#6366f1]" data-id="element-103" />
                      <span data-id="element-104">Envío gratis</span>
                      <ClockIcon size={18} className="ml-4 mr-2 text-[#6366f1]" data-id="element-105" />
                      <span data-id="element-106">Entrega: 24-48h</span>
                    </div>
                    <div className="flex items-center justify-center md:justify-end text-[#4a5568] mb-6 group" data-id="element-107">
                      <DollarSignIcon size={18} className="mr-2 text-[#4ade80] group-hover:rotate-12 transition-transform" data-id="element-108" />
                      <span className="font-medium group-hover:text-[#4ade80] transition-colors" data-id="element-109">
                        Ahorra $2,900 USD al año en productividad
                      </span>
                    </div>
                    <div className="bg-[#4ade80] text-white px-3 py-1 rounded-full inline-block text-sm font-medium animate-pulse hover:scale-105 transition-transform" data-id="element-110">
                      Oferta por tiempo limitado
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center" data-id="element-111">
                <button className="bg-[#8b5cf6] hover:bg-[#7c3aed] text-white px-10 py-5 rounded-full text-xl font-medium transition-all transform hover:scale-105 shadow-lg w-full md:w-auto hover:shadow-xl relative overflow-hidden group" onClick={handleMainCTAClick} data-id="element-112">
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-[#8b5cf6] to-[#7c3aed] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-113"></span>
                  <span className="relative" data-id="element-114">
                    Quiero mi rutina de alivio ahora{' '}
                    <ArrowRightIcon size={20} className="inline ml-2 group-hover:translate-x-1 transition-transform" data-id="element-115" />
                  </span>
                </button>
                <p className="mt-4 text-[#4a5568] italic" data-id="element-116">
                  Porque lo más caro que puedes hacer... es{' '}
                  <span className="font-bold text-[#e53e3e]" data-id="element-117">
                    no hacer nada
                  </span>
                  .
                </p>
                <p className="mt-6 text-[#718096] text-sm" data-id="element-118">
                  Pago seguro · 30 días de garantía · Soporte 24/7
                </p>
                {/* Logos de pago y garantía */}
                <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-119">
                  <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8" data-id="element-120">
                    <div className="flex items-center group" data-id="element-121">
                      <ShieldIcon size={20} className="text-[#4ade80] mr-2 group-hover:scale-110 transition-transform" data-id="element-122" />
                      <span className="text-sm font-medium text-[#4a5568] group-hover:text-[#4ade80] transition-colors" data-id="element-123">
                        Compra Segura
                      </span>
                    </div>
                    <div className="flex items-center group" data-id="element-124">
                      <CheckCircleIcon size={20} className="text-[#4ade80] mr-2 group-hover:scale-110 transition-transform" data-id="element-125" />
                      <span className="text-sm font-medium text-[#4a5568] group-hover:text-[#4ade80] transition-colors" data-id="element-126">
                        Garantía 30 días
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-127">
                      <img src="https://cdn.iconscout.com/icon/free/png-256/free-visa-3-226460.png" alt="Visa" className="h-8 w-auto" width="32" height="32" loading="lazy" data-id="element-128" />
                    </div>
                    <div className="flex items-center" data-id="element-129">
                      <img src="https://cdn.iconscout.com/icon/free/png-256/free-mastercard-3-226462.png" alt="Mastercard" className="h-8 w-auto" width="32" height="32" loading="lazy" data-id="element-130" />
                    </div>
                    <div className="flex items-center group" data-id="element-131">
                      <CreditCardIcon size={20} className="text-[#4a5568] mr-2 group-hover:scale-110 transition-transform" data-id="element-132" />
                      <span className="text-sm font-medium text-[#4a5568] group-hover:text-[#6366f1] transition-colors" data-id="element-133">
                        Pago Contra Entrega
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(CTASection);